import React, { useContext, useState } from "react";
import { EssealDataTable } from "esseal-data-table";
import { Button } from "@mui/material";
import humanResourceColumns from "./humanResourceColumns";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import CreateResourceUser from "./CreateResourceUser";
import { CompanyResource, PermissionActionEnum, PermissionEntityEnum } from "@/graphql/generated/graphql";
import BulkImportResourcesModal from "@/shared-components/BulkImportResourcesModal";
import PermissionContext from "@/Contexts/Permissions";
import RequestPermissionTooltip from "@/components/RequestPermissionTooltip";

interface CompanyHumansTableProps {
  loading: boolean;
  data: CompanyResource[];
}
const CompanyHumansTable: React.FC<CompanyHumansTableProps> = ({
  data,
  loading,
}) => {
  const [selectedResource, setSelectedResource] = useState<CompanyResource | null>(null);

  const [showCreateModal, setShowCreateModal] = useState(false);

  const { canPerformAction, checkRequestExists, requestPermission } = useContext(PermissionContext);
  const { Create, Manage } = PermissionActionEnum;
  const { EmployeeManagement } = PermissionEntityEnum;
  const hasCreatePermission = canPerformAction(Create, EmployeeManagement);
  const hasManagePermission = canPerformAction(Manage, EmployeeManagement);

  const createPermissionTooltipProps = {
    hasPermission: hasCreatePermission,
    requiredPermission: { action: Create, entity: EmployeeManagement },
    checkRequestExists,
    onRequest: requestPermission,
  }

  return (
    <React.Fragment>
      <EssealDataTable
        rows={data}
        columns={humanResourceColumns}
        loading={loading}
        checkboxSelection={false}
        pagination={true}
        pageSize={25}
        rowActions={(row) => [
          {
            label: 'Add User',
            icon: <PersonAddAltIcon fontSize="small" color={hasManagePermission ? "primary" : "disabled"} />,
            // TODO: There Should be ability to disable this manually in case of user already exists
            tooltip: 'Create User',
            disabled: !hasManagePermission,
            onClick: () => {
              setSelectedResource(row as CompanyResource);
            }
          }
        ]}
        toolbar={
          <RequestPermissionTooltip {...createPermissionTooltipProps}>
            <Button
              disabled={!hasCreatePermission}
              onClick={() => setShowCreateModal(true)}
            >
              + Add New
            </Button>
          </RequestPermissionTooltip>
        }
      />

      {selectedResource &&
        <CreateResourceUser resource={selectedResource} handleClose={() => setSelectedResource(null)} />
      }

      {showCreateModal &&
        <BulkImportResourcesModal importType="human" handleClose={() => setShowCreateModal(false)} />
      }
    </React.Fragment>
  );
};

export default CompanyHumansTable;
